export default __webpack_public_path__ + "14a836b07589629f648dc65c20caf29d.svg";